import React, { useEffect } from 'react';

export default function YTVideo({ videoId }) {
  // Debug logging when component mounts or videoId changes
  useEffect(() => {
    // Analyze the videoId structure if it's an object
    if (typeof videoId === 'object' && videoId !== null) {
    }
  }, [videoId]);

  // Handle different types of inputs that might be received
  const extractVideoId = (input) => {
    
    // If it's null or undefined
    if (!input) {
      return null;
    }
    
    // If it's already a simple string ID
    if (typeof input === 'string' && !input.includes('/') && !input.includes('.')) {
      return input;
    }
    
    // If it's a full YouTube URL
    try {
      if (typeof input === 'string') {
        if (input.includes('youtu.be/')) {
          return input.split('youtu.be/')[1].split('?')[0];
        } else if (input.includes('youtube.com/watch')) {
          const url = new URL(input);
          return url.searchParams.get('v');
        } else if (input.includes('youtube.com/embed/')) {
          return input.split('youtube.com/embed/')[1].split('?')[0];
        }
      }
    } catch (e) {
    }
    
    return input; // Return as-is if we couldn't extract
  };

  // Get the final video ID to use
  const finalVideoId = extractVideoId(videoId);
  
  // Render a message if no valid ID could be found
  if (!finalVideoId) {
    return (
      <div className="w-full p-6 bg-red-50 rounded-lg text-center">
        <h3 className="text-red-600 font-semibold mb-2">Video Unavailable</h3>
        <p className="text-gray-700">Could not load the YouTube video (missing or invalid ID).</p>
        <p className="text-gray-500 text-sm mt-2">Debug info: received {JSON.stringify(videoId)}</p>
      </div>
    );
  }

  return (
    <div className="aspect-w-16 aspect-h-9 w-full overflow-hidden rounded-lg">
      <iframe
        src={`https://www.youtube.com/embed/${finalVideoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="w-full h-full"
      ></iframe>
    </div>
  );
}
